<template>
  <b-modal v-model="showModal" title="Add New Management Server">
    <div v-if="!formValid" class="alert p-0"><b>{{errorMessage}}</b></div>
    <b-form ref="form">
      <!--  key control -->
      <b-form-group label="Key *" label-for="key" invalid-feedback="Please enter a Unique key.">
        <b-form-input id="key" v-model="addMediaNodeObj.key" placeholder="Unique Key"></b-form-input>
      </b-form-group>
      <!--  URL   control -->
      <b-form-group label="URL *" label-for="url" invalid-feedback="Please enter valid Pexip Management URL.">
        <b-form-input id="url" v-model="addMediaNodeObj.url" placeholder="Management URL"></b-form-input>
      </b-form-group>
      <b-form-group>
        <b-form-checkbox id="checkbox-recurring" v-model.bool="addMediaNodeObj.staticPin" name="staticPin"
                         unchecked-value="false" value="true" inline>
          Is Static Pin ?
        </b-form-checkbox>
      </b-form-group>
      <!--  URL   control -->
      <b-form-group label="Token *" label-for="token" invalid-feedback="Please enter token.">
        <b-form-input id="token" v-model="addMediaNodeObj.token " placeholder="Auth Token"></b-form-input>
      </b-form-group>
      <!-- nodeFilter  -->
      <b-form-group label="Node Filter" label-for="nodeFilter" invalid-feedback="Please enter node filter.">
        <b-form-input id="nodeFilter" v-model="addMediaNodeObj.nodeFilter " placeholder="Node Filter"></b-form-input>
      </b-form-group>
      <!-- proxyNodeFilter  -->
      <b-form-group label="Node Filter" label-for="proxyNodeFilter"
                    invalid-feedback="Please enter proxy node filter.">
        <b-form-input id="proxyNodeFilter" v-model="addMediaNodeObj.proxyNodeFilter "
                      placeholder="Proxy Node Filter"></b-form-input>
      </b-form-group>
      <b-form-group label="SDK Version" label-for="pexipSDKVersion"
                    invalid-feedback="Please select pexip SDK version.">
        <b-form-select id="pexipSDKVersion" class="languageWrapperSelect" v-model="addMediaNodeObj.pexipSDKVersion"
                       style="width: 100%" :options="pexipSDKVersionOptionArray" >
        </b-form-select>
      </b-form-group>

    </b-form>
    <template #modal-footer>
      <b-button variant="secondary" @click="showModal = false">Close</b-button>
      <b-button variant="primary" @click="saveChanges">Save Changes</b-button>
    </template>
  </b-modal>
</template>

<script>


export default {
  props: ['pexipMgtConfig', 'staticConfiguration', 'lastSelectedTenant'],
  data() {
    return {
      showModal: false,
      pexipSDKVersionOptionArray:[
        {text:'V30.1',value:'V30_1'},
        {text:'v26.2',value:'V26_2'},
      ],
      addMediaNodeObj: {
        pexipSDKVersion: "V30_1"
      },
      formValid: true,
      errorMessage: ""
    };
  },
  watch: {
    showModal(newVal) {
      this.addMediaNodeObj = {
        pexipSDKVersion: "V30_1"
      };
      this.formValid = true;
      this.errorMessage = "";
    }
  },
  methods: {
    async saveChanges() {
      this.formValid = true;
      this.errorMessage = "";
      // Handle saving changes here
      if (this.validateData()) {
        console.log('saveChanges', this.addMediaNodeObj, this.pexipMgtConfig, this.staticConfiguration);
        this.saveManagementServer();
      }
    },
    validateData() {
      if (!this.addMediaNodeObj.key || !this.addMediaNodeObj.url || !this.addMediaNodeObj.token || !this.addMediaNodeObj.pexipSDKVersion) {
        this.errorMessage = "All fields with * are REQUIRED.";
        this.formValid = false;
      }
      return this.formValid;
    },
    async saveManagementServer() {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url = config.OPERATIONS_SERVICE + `/tenants/${this.lastSelectedTenant}/virtual-media-info`;
      var pexipManagementPostRequest = new Request(url, {
        method: "POST",
        mode: "cors",
        withCredentials: true,
        credentials: "include",
        body: JSON.stringify(this.addMediaNodeObj),
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json"
        }
      });

      try {
        var savePexipManagementResponse = await fetch(pexipManagementPostRequest);
        if (savePexipManagementResponse.status === 503) {
          return this.saveManagementServer();
        }
        if (savePexipManagementResponse.status === 200) {
          this.$emit('managementServerSaved');
          this.showModal = false;
        }
        const savePexipManagementResponseBody = await savePexipManagementResponse.json();
        console.log("savePexipManagementResponse", savePexipManagementResponseBody);
        this.errorMessage = "Failed to save the Pexip Management Server with Error"
        if (savePexipManagementResponse.status === 400 && savePexipManagementResponseBody.error) {
          const errorMessage = savePexipManagementResponseBody.error;
          if (errorMessage) {
            const errorMessageTemp = errorMessage.split(':');
            if (errorMessageTemp.length > 0) {
              this.errorMessage = errorMessageTemp[1];
            }
          }
        }
        this.formValid = false;
      } catch (error) {
        console.error(error);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.alert {
  color: #d43d3d;
}
</style>/